/** ສະແດງຈຳນວນເງິນເປັນກີບ */
export function money(amount: string | number): string {
  return `${new Intl.NumberFormat('lo-LA', { maximumFractionDigits: 0 }).format(Number(amount))} ກີບ`;
}

/** ວັນທີເວລາຕາມເວລາລາວ */
export function laoDateTime(iso: string | null): string {
  if (!iso) return '—';
  return new Date(iso).toLocaleString('lo-LA', {
    timeZone: 'Asia/Vientiane',
    dateStyle: 'medium',
    timeStyle: 'short',
  });
}

/** ວັນທີຕາມເວລາລາວ (YYYY-MM-DD) — offsetDays ລົບ = ມື້ກ່ອນ */
export function laoToday(offsetDays = 0): string {
  return new Date(Date.now() + 7 * 3_600_000 + offsetDays * 86_400_000).toISOString().slice(0, 10);
}
